/**
 * formatGradeLabel — mirror of backend `utils/grade_labels.format_grade_label`.
 *
 * Single source of truth (frontend side) for building an event's
 * grade + discipline label with inline "Mens" / "Ladies" for
 * single-gender events, or a trailing "(M)" for male_only_combined
 * (mixed events with males stapled on).
 *
 * Feb 2026 — keep this function in lock-step with the Python helper
 * so backend-rendered docs and frontend-rendered UI always agree.
 *
 * @param {string} gradeName        e.g. "Advanced Masters"
 * @param {string} disciplineName   e.g. "Solo Dance"
 * @param {object} [opts]
 * @param {string} [opts.gender_split]        "M" | "F" | null
 * @param {string} [opts.sub_block]           "M" | "F" | null (per-record)
 * @param {boolean} [opts.male_only_combined] mixed event with males last
 * @returns {string}
 */
export function formatGradeLabel(gradeName, disciplineName, opts = {}) {
  const grade = (gradeName || '').trim();
  const discipline = (disciplineName || '').trim();
  const { gender_split = null, sub_block = null, male_only_combined = false } = opts;

  let genderWord = null;
  if (sub_block === 'M' || gender_split === 'M') genderWord = 'Mens';
  else if (sub_block === 'F' || gender_split === 'F') genderWord = 'Ladies';

  if (genderWord) {
    return [grade, genderWord, discipline].filter(Boolean).join(' ');
  }

  const base = grade ? `${grade} ${discipline}`.trim() : discipline;
  return male_only_combined ? `${base} (M)`.trim() : base;
}
